function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 12.0002C2 6.47803 6.47779 2.00024 12 2.00024C17.5229 2.00024 22 6.4777 22 12.0002C22 17.5228 17.5229 22.0002 12 22.0002C6.47779 22.0002 2 17.5225 2 12.0002ZM20.5 12.0002C20.5 7.3061 16.6944 3.50024 12 3.50024C7.30621 3.50024 3.5 7.30646 3.5 12.0002C3.5 16.694 7.30621 20.5002 12 20.5002C16.6944 20.5002 20.5 16.6944 20.5 12.0002ZM11.9951 7.45434C12.3748 7.45434 12.6886 7.7365 12.7383 8.10257L12.7451 8.20434V12.6233C12.7451 13.0376 12.4093 13.3733 11.9951 13.3733C11.6154 13.3733 11.3016 13.0912 11.2519 12.7251L11.2451 12.6233V8.20434C11.2451 7.79013 11.5809 7.45434 11.9951 7.45434ZM12.7551 15.7961C12.7551 15.3819 12.4193 15.0461 12.0051 15.0461L11.8933 15.053C11.5273 15.1027 11.2451 15.4164 11.2451 15.7961C11.2451 16.2104 11.5809 16.5461 11.9951 16.5461L12.1069 16.5393C12.4729 16.4896 12.7551 16.1758 12.7551 15.7961Z",
  fill: "#BF2600"
});

function SvgInputError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputError);
export default __webpack_public_path__ + "static/media/input-error.dd141ca4.svg";
export { ForwardRef as ReactComponent };